import React, { useState } from 'react';
import { SoldProjectsCard } from '../schedule/SoldProjectsCard';
import AddEditWorkModal from '../schedule/AddEditWorkModal';

// Admin → Portal de Vendas → "Projetos vendidos": mesmo card do painel inicial + modal do calendário p/ agendar
const SalesJobRequestsPanel = ({ language = 'pt-BR' }) => {
  const [project, setProject] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div data-testid="sales-job-requests-panel">
      <SoldProjectsCard language={language} embedded refreshKey={refreshKey} onSchedule={(p) => setProject(p)} />
      <AddEditWorkModal
        isOpen={Boolean(project)}
        onClose={() => setProject(null)}
        work={null}
        date={new Date()}
        onSuccess={() => setRefreshKey((k) => k + 1)}
        language={language}
        userRole="admin"
        fromProject={project}
      />
    </div>
  );
};

export default SalesJobRequestsPanel;
